/** Fields the default card shows: option sets and people, in the projects' own field order. */
const DEFAULT_KINDS = new Set(["enum", "state", "user"]);
/** Every field of the board's projects, in `project_fields` ordinal order, each one listed once. */
export function boardProjectFields(board, schema) {
    const out = [];
    const seen = new Set();
    for (const projectId of board.projectIds) {
        for (const pf of schema.projectFieldsByProject.get(projectId) ?? []) {
            if (seen.has(pf.fieldId))
                continue;
            const f = schema.fieldsById.get(pf.fieldId);
            if (!f)
                continue;
            seen.add(pf.fieldId);
            out.push(f);
        }
    }
    return out;
}
/**
 * The card's fields, resolved: what the board stores, or — when it stores
 * nothing (a board nobody has configured, or one just put back to "Restore
 * default") — every option-set and user field of its projects, fully spelled
 * out. The column field is never on a card: its value is the column.
 *
 * One list for the board page and the settings table, so what the table shows
 * is exactly what the cards render.
 */
export function boardCardFields(board, schema) {
    if (board.cardFields !== null)
        return board.cardFields.filter((c) => schema.fieldsById.has(c.fieldId) && c.fieldId !== board.columnFieldId);
    return boardProjectFields(board, schema)
        .filter((f) => f.id !== board.columnFieldId && DEFAULT_KINDS.has(f.kind))
        .map((f) => ({ fieldId: f.id, display: "full" }));
}
//# sourceMappingURL=board-card.js.map